import type { FC, PropsWithChildren } from 'react';
import type { ScrollViewProps } from 'react-native';
import { ScrollView, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  view: { flex: 1, flexGrow: 1 },
  content: {
    flex: 1,
    flexGrow: 1,
    alignItems: 'center'
  }
});

export const FallbackWrapper: FC<ScrollViewProps & PropsWithChildren> = ({
  children,
  ...scrollViewProps
}) => (
  <ScrollView
    {...scrollViewProps}
    style={styles.view}
    contentContainerStyle={[
      scrollViewProps.contentContainerStyle,
      styles.content
    ]}
  >
    {children}
  </ScrollView>
);
